import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

interface DonutPanel {
  id: string;
  header: string;
  element: any;
  legendData: Array<{ label: string; value: number; color: string; formattedValue: string; metricType: string }>;
}

@Component({
  selector: 'app-inbuilt-header-v2',
  standalone: false,
  templateUrl: './inbuilt-donut-v2.component.html',
  styleUrl: './inbuilt-donut-v2.component.css'
})
export class InbuiltHeaderV2Component implements OnInit, OnChanges {

  @Input() config: any;
  @Input() elementData: any = null;

  donutPanels: DonutPanel[] = [];

  constructor() {}

  ngOnInit(): void {
    this.initializePanels();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config'] || changes['elementData']) {
      this.initializePanels();
    }
  }

  onPanelSeriesChange(index: number, series: Array<{ label: string; value: number; color: string; formattedValue: string; metricType: string }>): void {
    if (!this.donutPanels[index]) {
      return;
    }

    this.donutPanels[index].legendData = Array.isArray(series) ? series : [];
  }

  isDonutVisual(element: any): string {
    const normalizedType = this.normalizeType(element?.type);
    
    return normalizedType ;
  }

  onChartReady(_: number): void {}

  getDonutChartWidth(): number {
    const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1366;
    const panelCount = Math.max(1, this.donutPanels?.length || 1);

    if (viewportWidth < 576) {
      return Math.max(320, Math.min(420, viewportWidth - 32));
    }

    const availablePerPanel = Math.floor((viewportWidth - 120) / panelCount);
    return Math.max(420, Math.min(620, availablePerPanel));
  }

  getDonutChartHeight(): number {
    const width = this.getDonutChartWidth();
    return Math.max(320, Math.min(460, Math.floor(width * 0.78)));
  }

  getDonutExternalLabelScale(): number {
    const width = this.getDonutChartWidth();
    if (width >= 500) {
      return 0.72;
    }
    if (width >= 420) {
      return 0.62;
    }
    return 0.5;
  }

  private initializePanels(): void {
    const elements = this.getTargetElements();
    this.donutPanels = elements.map((child: any, index: number) => ({
      id: `${index}_${String(child?.name || 'donut')}`,
      header: String(child?.name || `Donut ${index + 1}`),
      element: child,
      legendData: []
    }));
  }

  private getTargetElements(): any[] {
    if (Array.isArray(this.elementData?.children) && this.elementData.children.length > 0) {
      return this.elementData.children;
    }

    return this.elementData ? [this.elementData] : [];
  }

  private normalizeType(type: any): string {
    return String(type ?? '').trim().toLowerCase();
  }
}

